import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

function useUserDetails(isLoggedIn) {
  return useQuery({
    queryKey: ['user', 'user-details'],
    queryFn: async () => {
      const { data } = await axios.get('/api/user');
      return data;
    },
    enabled: isLoggedIn,
    retry: false,
  });
}

export {
  useUserDetails,
};
